import React from "react";
import PropTypes from "prop-types";

const SideBarAddLogo = ({ bgColor = "#0e0e0e" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M9.16634 9.16658V3.33325H10.833V9.16658H16.6663V10.8333H10.833V16.6666H9.16634V10.8333H3.33301V9.16658H9.16634Z"
        fill={bgColor}
      />
    </svg>
  );
};

SideBarAddLogo.propTypes = {
  bgColor: PropTypes.string,
};

export default SideBarAddLogo;
